// Actiondan gelen datalar ile stateler güncellenecek
export const stockLoading = (state, payload) => {
  state.loading = payload
}

export const setStockStatus = (state, payload) => {
  state.stockStatus = payload
}

export const setStocks = (state, payload) => {
  state.stocks = payload.data ? payload.data : []
  state.stockPageInfo = payload.list_info

}

export const setStock = (state, payload) => {
  state.stock = payload.data
}

export const setMovements = (state, payload) => {
  state.movements = payload.data ? payload.data : []
  state.movementPageInfo = payload.list_info

}

export const setMovementTypes = (state, payload) => {
  state.movementTypes = payload.data
}

export const setFaultSupports = (state, payload) => {
  state.faultSupports = payload.data ? payload.data : []
  state.faultSupportPageInfo = payload.list_info
}

export const setFaultSupport = (state, payload) => {
  state.faultSupport = payload.data
}

export const setFaultStatuses = (state, payload) => {
  state.faultStatuses = payload.data
}

export const setFaultSupportImages = (state, payload) => {
  state.faultSupportImages = payload.data
}

export const setPieces = (state, payload) => {
  state.pieces = payload.data
}

export const setFaultSupportPieces = (state, payload) => {
  state.faultSupportPieces = payload.data
}

export const setFaultSupportResults = (state, payload) => {
  state.faultSupportResults = payload.data ? payload.data : []
}

export const setFaultTracking = (state, payload) => {
  state.faultTracking = payload.data ? payload.data.data : {}
}

export const untrackInfo = (state, payload) => {
  state.untrackInfo = payload.data ? payload.data : []
}

export const stockMovementDetail = (state, payload) => {
  state.stockMovement = payload.data 
}


// WEBPACK FOOTER //
// ./src/store/modules/Stock/Mutations.js